
import Speaker from "../../../assets/duotone/Speaker.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SpeakerIcon({ className, dataTestid = "SpeakerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Speaker data-testid={dataTestid} className={classes} {...rest} />
  );
}
